import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FiInfo, FiX } from 'react-icons/fi'
import type { BoxProps } from '@chakra-ui/react'
import { Box, Flex, Text, HStack } from '@chakra-ui/react'

import OutlineBox from '~components/shared/wrappers/outline-box'
import { Button } from '@chakra-ui/react'
import NewTag from '~components/shared/tags/new-tag'

interface Props {
    title: string
    hintText?: string[]
    isFilled?: boolean
    isMakingNew?: boolean
    onRemove: () => void
}

export default function EntityBox({
    title,
    hintText,
    isFilled,
    isMakingNew,
    onRemove,
}: Props) {
    const boxProps: BoxProps = isFilled
        ? {
              bg: 'white',
          }
        : {
              bg: 'gray.100',
              shadow: 'inner',
          }

    return (
        <OutlineBox w="full" {...boxProps}>
            <Flex w="full" justifyContent="space-between" alignItems="center">
                <HStack spacing={4}>
                    {isMakingNew && <NewTag />}
                    <Box>
                        <Text fontWeight="semibold" mb={-0.5}>
                            {title}
                        </Text>
                        {hintText &&
                            hintText.map((text, idx) => (
                                <Text key={idx} fontSize="xs" color="gray.500">
                                    {text}
                                </Text>
                            ))}
                    </Box>
                </HStack>
                {isFilled ? (
                    <Button
                        size="sm"
                        shadow="blue.md"
                        rightIcon={<Icon as={FiX} />}
                        onClick={onRemove}
                    >
                        Remove
                    </Button>
                ) : (
                    <BookingInfoIndicator />
                )}
            </Flex>
        </OutlineBox>
    )
}

function BookingInfoIndicator() {
    return (
        <HStack>
            <Icon as={FiInfo} color="gray.600" />
            <Text fontSize="xs" color="gray.600">
                Information recieved from the client at the time of booking.
            </Text>
        </HStack>
    )
}
